export interface ProductLogoProps {
    width?: string;
}

const ProductLogo = (props: ProductLogoProps): React.ReactElement => {
    const { width } = props;

    const imgUrl = '/Content/img/RISLogo3_w.png';
    const imageWidth = width ?? '350px';

    return <img src={imgUrl} width={imageWidth} alt="Product Logo" />;
};

export default ProductLogo;
